import { render, staticRenderFns } from "./UnlinkMatch.vue?vue&type=template&id=b1baf7de"
import script from "./UnlinkMatch.vue?vue&type=script&lang=js"
export * from "./UnlinkMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports